<template>
  <b-card>
    <div slot="header">
      <b v-text="title" />
    </div>
    <b-row>
      <b-col cols="12" md="12">
        <LoadingSpinner :loading="isLoading" />
      </b-col>
      <b-col cols="12" md="12" v-if="!isLoading && examPacks.length">
        <a
          target="_blank"
          v-for="(item, key) in examPacks"
          :key="key"
          class="btn btn-info text-white m-2"
          :href="pathOr('#', ['address'], item)"
          v-text="pathOr('', ['exam_pack', 'name'], item)"
        />
      </b-col>
      <b-col cols="12" md="12" v-if="!isLoading && !examPacks.length">
        <b-alert show variant="danger" v-text="$lang.no_exam_pack_exist" />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { pathOr } from "ramda";
import LoadingSpinner from "@/components/base/LoadingSpinner";

export default {
  components: {
    LoadingSpinner,
  },
  props: {
    title: {
      type: String,
      default: "لیست پرسشنامه‌ها",
    },
    parentLoading: {
      type: Boolean,
      default: false,
    },
    azmoonData: {
      type: Array,
      default: () => [],
    },
    personCode: {
      type: String,
      default: null,
    },
    operatorCode: {
      type: String,
      default: null,
    },
    referenceCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      examPacks: [],
      loading: false,
    };
  },
  watch: {
    azmoonData(data) {
      data.length && this.generateExamPacks();
    },
  },
  computed: {
    isLoading() {
      return this.parentLoading || this.loading;
    },
  },
  methods: {
    pathOr,
    generateExamPacks() {
      this.examPacks = [];
      this.azmoonData.forEach(
        async (item) => await this.getAzmoonExecute(item.id)
      );
    },
    async getAzmoonExecute(azmoonId) {
      try {
        this.examPacks = [];
        this.loading = true;
        const url =
          this.$config.api_url +
          this.$config.resources.azmoon_execute
            .replace("{0}", azmoonId)
            .replace("{1}", this.personCode)
            .replace("{2}", this.operatorCode)
            .replace("{3}", this.referenceCode);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.examPacks = [...this.examPacks, ...data];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
